import { render, staticRenderFns } from "./shop-result.vue?vue&type=template&id=095c5fa4&"
import script from "./shop-result.vue?vue&type=script&lang=js&"
export * from "./shop-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports